import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="writablestreamdefaultcontroller" id="writablestreamdefaultcontroller"></a>
    <h1 {...{
      "id": "windowwritablestreamdefaultcontroller"
    }}>{`window.WritableStreamDefaultController`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/WritableStreamDefaultController"
      }}>{`Web APIs - WritableStreamDefaultController`}</a>{`  `}</p>
    <a name="writablestreamdefaultcontroller-signal" id="writablestreamdefaultcontroller-signal"></a>
    <h2 {...{
      "id": "signal--abortsignal"
    }}>{`signal : `}<inlineCode parentName="h2">{`AbortSignal`}</inlineCode></h2>
    <p>{`Returns AbortSignal that can be used to abort the pending write or close operation when the stream is aborted.`}</p>
    <a name="writablestreamdefaultcontroller-error" id="writablestreamdefaultcontroller-error"></a>
    <h2 {...{
      "id": "errormessage"
    }}>{`error(message)`}</h2>
    <p>{`Closes the controlled writable stream, making all future interactions with it fails with the given error.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      